import type { ExportDeviceInventoryParams, GetDeviceInventoryCountParams, GetDeviceInventoryParams } from '../query/type';
import type { SearchSchema } from '../searchSchema';
type CatalogScope = {
  catalogId?: string;
};
export function buildDeviceInventoryListQueryParams(search: SearchSchema, {
  catalogId
}: CatalogScope = {}): GetDeviceInventoryParams {
  return {
    ...(catalogId ? {
      catalogId
    } : {}),
    category: search.category,
    genres: search.genres,
    placementPlaceIds: search.placementPlaceIds,
    warehousingPlaceIds: search.warehousingPlaceIds,
    orderBy: search.sortColumn,
    orderDirection: search.sortOrder,
    freeText: search.freeText,
    page: search.pageIndex + 1,
    pageSize: search.pageSize
  };
}
export function buildDeviceInventoryExportQueryParams(search: SearchSchema, {
  catalogId
}: CatalogScope = {}): ExportDeviceInventoryParams {
  return {
    ...(catalogId ? {
      catalogId
    } : {}),
    category: search.category,
    freeText: search.freeText,
    genres: search.genres,
    placementPlaceIds: search.placementPlaceIds,
    warehousingPlaceIds: search.warehousingPlaceIds
  };
}
export function buildDeviceInventoryCountQueryParams(catalogId?: string): GetDeviceInventoryCountParams | undefined {
  return catalogId ? {
    catalogId
  } : undefined;
}